import { observer } from "mobx-react-lite";
import { LearningStore } from "./learning_store";
import { PageHeading } from "./learning_lobby";
import { percent } from "./learning_statistics";

export const ProfileScreen = observer(({ store }: { store: LearningStore }) => (
  <>
    <PageHeading title="Личный кабинет" />
    <section className="portal-card profile-card">
      <div className="profile-avatar" aria-hidden="true">
        {store.user?.username.slice(0, 1).toUpperCase()}
      </div>
      <div>
        <h2>{store.user?.username}</h2>
        <p className="portal-muted">
          {store.user?.role === "admin" ? "Администратор" : "Ученик"}
        </p>
      </div>
    </section>
    <section className="portal-card profile-progress">
      <h2>Мой прогресс</h2>
      {store.statisticsError ? (
        <p role="alert">{store.statisticsError}</p>
      ) : (
        <dl>
          <div>
            <dt>Завершено тестов</dt>
            <dd>{store.statistics?.completed || 0}</dd>
          </div>
          <div>
            <dt>Пройдено заданий</dt>
            <dd>{store.statistics?.solvedTasks || 0}</dd>
          </div>
          <div>
            <dt>Общая успеваемость</dt>
            <dd>
              {store.statistics
                ? percent(store.statistics.score, store.statistics.maxScore)
                : "—"}
            </dd>
          </div>
        </dl>
      )}
      <a className="profile-link" href="#statistics">
        Открыть статистику →
      </a>
    </section>
  </>
));
